module.exports = __webpack_public_path__ + "static/media/russell_herman_bw.d68ce03e.jpg";